import { Link } from '@inertiajs/react'

type TabId = 'dashboard' | 'users' | 'question_templates'

type Props = {
  active: TabId
  showUsers: boolean
  showTemplates?: boolean
}

type Tab = { id: TabId; label: string; href: string }

export default function TabStrip({ active, showUsers, showTemplates = false }: Props) {
  const tabs: Tab[] = [{ id: 'dashboard', label: 'Dashboard', href: '/dashboard' }]
  if (showUsers) tabs.push({ id: 'users', label: 'User Management', href: '/users' })
  if (showTemplates) tabs.push({ id: 'question_templates', label: 'Question Templates', href: '/question_templates' })

  return (
    <nav className="bg-white shadow-sm">
      <div className="mx-auto flex w-full max-w-[1440px] gap-6 px-5 md:px-10">
        {tabs.map((tab) => {
          const isActive = tab.id === active
          return (
            <Link
              key={tab.id}
              href={tab.href}
              className={`relative py-4 font-display font-medium transition ${
                isActive ? 'text-midnight-green' : 'text-gray-500 hover:text-midnight-green'
              }`}
            >
              {tab.label}
              {isActive && (
                <span className="absolute inset-x-0 -bottom-px h-0.5 bg-midnight-green" />
              )}
            </Link>
          )
        })}
      </div>
    </nav>
  )
}
